export enum ViewToolsMode {
  Main,
  Media,
  Tools,
  Whiteboard,
  VisibilityLayers,
  Empty
}
